export default "__VITE_ASSET__51965504__"